import { BN } from '@drift-labs/sdk';
import { BigNum } from '@drift-labs/sdk';
import ValueDisplay from 'src/components/ValueDisplay';
import { useCollateralValueRequiredForTrade } from '../hooks/useCollateralValueRequiredForTrade';

interface MarginRequiredTradeDetailsProps {
	marginRequired?: BigNum;
	baseSizeStringValue: string;
	selectedMarketIndex: number;
	estEntryPrice: BN;
}

export const MarginRequiredTradeDetails = ({
	marginRequired,
	baseSizeStringValue,
	selectedMarketIndex,
	estEntryPrice,
}: MarginRequiredTradeDetailsProps) => {
	if (marginRequired) {
		return (
			<ValueDisplay.Default
				label="Margin Required"
				value={marginRequired.toNotional()}
			/>
		);
	}
	return (
		<CalculatedMarginRequiredTradeDetails
			baseSizeStringValue={baseSizeStringValue}
			selectedMarketIndex={selectedMarketIndex}
			estEntryPrice={estEntryPrice}
		/>
	);
};

interface CalculatedMarginRequiredTradeDetailsProps {
	baseSizeStringValue: string;
	selectedMarketIndex: number;
	estEntryPrice: BN;
}

const CalculatedMarginRequiredTradeDetails = ({
	baseSizeStringValue,
	selectedMarketIndex,
	estEntryPrice,
}: CalculatedMarginRequiredTradeDetailsProps) => {
	const collateralReq = useCollateralValueRequiredForTrade({
		baseSizeString: baseSizeStringValue,
		marketIndex: selectedMarketIndex,
		estEntryPrice,
	});

	return (
		<ValueDisplay.Default
			label="Margin Required"
			value={collateralReq.toNotional()}
		/>
	);
};
